import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticlesSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const els = sectionRef.current?.querySelectorAll(".reveal-article");
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="artykuly" className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Artykuły i przewodniki
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Poznaj sekrety zakupów na Kakobuy. Nasze przewodniki pomogą Ci kupować mądrzej i bezpieczniej.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {articles.map((article, i) => (
            <Link
              key={article.id}
              to={`/blog/${article.slug}`}
              className="reveal-article opacity-0 translate-y-8 transition-all duration-700 ease-out group block bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/40 hover:shadow-md"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 text-sm font-medium px-6 py-3 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            Przejdź do Kakobuy Spreadsheet
            <i className="ri-external-link-line" />
          </a>
        </div>
      </div>

      <style>{`
        .reveal-article.animate-in {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}